module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Cấu hình lương cho saller",
      "breadcrumbs": [{
        title: 'Quản lý saler',
        route: {
          name: 'saler'
        }
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('el-form', {
    ref: "config-saler-salary",
    attrs: {
      "model": _vm.localConfig,
      "rules": _vm.rules,
      "label-width": "200px",
      "label-position": "top"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmit()
      }
    }
  }, [_c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "KPI",
      "prop": "config.kpi"
    }
  }, [_c('el-row', {
    staticClass: "margin-sm-bottom",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 3
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Số vận đơn")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Số tiền / 1 đơn")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Tiền thưởng")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Thêm tháng tích lũy")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 1
    }
  }, [_vm._v(" ")])], 1), _vm._v(" "), _vm._l((_vm.kpiConfig), function(kpi, index) {
    return _c('el-row', {
      key: index,
      staticClass: "margin-sm-bottom",
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_vm._v(_vm._s(index === 0 ? 'KPI tối thiểu' : 'Vượt chỉ tiêu'))]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      staticClass: "input-number-kpi",
      attrs: {
        "placeholder": "Số đơn"
      },
      model: {
        value: (_vm.kpiConfig[index]['number']),
        callback: function($$v) {
          _vm.$set(_vm.kpiConfig[index], 'number', $$v)
        },
        expression: "kpiConfig[index]['number']"
      }
    }, [_c('div', {
      attrs: {
        "slot": "prepend"
      },
      slot: "prepend"
    }, [_c('span', {
      staticClass: "text-red"
    }, [(parseInt(_vm.kpiConfig[index]['number']) !== -1) ? _c('span', [_vm._v("\n                          " + _vm._s(_vm._f("number")(index === 0 ? '0' : _vm.kpiConfig[index - 1]['number'])) + " - " + _vm._s(_vm._f("number")(_vm.kpiConfig[index]['number'])) + " đơn\n                        ")]) : _c('span', [_vm._v("\n                          > " + _vm._s(_vm._f("number")(_vm.kpiConfig[index - 1]['number'])) + " đơn\n                        ")])])])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Số tiền / 1 đơn"
      },
      model: {
        value: (_vm.kpiConfig[index]['money']),
        callback: function($$v) {
          _vm.$set(_vm.kpiConfig[index], 'money', $$v)
        },
        expression: "kpiConfig[index]['money']"
      }
    }, [_c('div', {
      attrs: {
        "slot": "append"
      },
      slot: "append"
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.kpiConfig[index]['money'])))])])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Tiền thưởng"
      },
      model: {
        value: (_vm.kpiConfig[index]['bonus']),
        callback: function($$v) {
          _vm.$set(_vm.kpiConfig[index], 'bonus', $$v)
        },
        expression: "kpiConfig[index]['bonus']"
      }
    }, [_c('div', {
      attrs: {
        "slot": "append"
      },
      slot: "append"
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.kpiConfig[index]['bonus'])))])])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Thêm tháng tích lũy"
      },
      model: {
        value: (_vm.kpiConfig[index]['month_plus']),
        callback: function($$v) {
          _vm.$set(_vm.kpiConfig[index], 'month_plus', $$v)
        },
        expression: "kpiConfig[index]['month_plus']"
      }
    }, [_c('div', {
      attrs: {
        "slot": "append"
      },
      slot: "append"
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v(_vm._s(_vm.kpiConfig[index]['month_plus']) + " tháng")])])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 1
      }
    }, [_c('a', {
      staticClass: "text-red cursor-pointer",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeKpi(_vm.kpiConfig, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])], 1)
  }), _vm._v(" "), _c('el-row', {
    staticClass: "margin-sm-bottom",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 24
    }
  }, [_c('a', {
    staticClass: "ui mini blue button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.newKpi(_vm.kpiConfig)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Thêm mới")])])], 1)], 2)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Số tiền / 1 đơn tích lũy",
      "prop": "config.salary_accumulation"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Số tiền / 1 đơn tích lũy"
    },
    model: {
      value: (_vm.localConfig.config.salary_accumulation),
      callback: function($$v) {
        _vm.$set(_vm.localConfig.config, "salary_accumulation", $$v)
      },
      expression: "localConfig.config.salary_accumulation"
    }
  }, [_c('div', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localConfig.config.salary_accumulation)))])])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Số tiền / 1 khách hàng mới",
      "prop": "config.salary_by_customer"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Số tiền / 1 khách hàng mới"
    },
    model: {
      value: (_vm.localConfig.config.salary_by_customer),
      callback: function($$v) {
        _vm.$set(_vm.localConfig.config, "salary_by_customer", $$v)
      },
      expression: "localConfig.config.salary_by_customer"
    }
  }, [_c('div', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localConfig.config.salary_by_customer)))])])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Số tháng tích lũy đơn",
      "prop": "config.month_accumulation"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Số tháng tích lũy đơn"
    },
    model: {
      value: (_vm.localConfig.config.month_accumulation),
      callback: function($$v) {
        _vm.$set(_vm.localConfig.config, "month_accumulation", $$v)
      },
      expression: "localConfig.config.month_accumulation"
    }
  }, [_c('div', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.localConfig.config.month_accumulation)) + " tháng")])])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "disabled": _vm.submitting,
      "native-type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v(" Lưu lại")]), _vm._v(" "), _c('button', {
    staticClass: "ui red basic small button",
    attrs: {
      "disabled": _vm.submitting,
      "type": "button"
    },
    on: {
      "click": _vm.resetConfig
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Đặt lại cấu hình mặc định")])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6f16aca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/salerConfig/SalerConfigByUser.vue
// module id = 659
// module chunks = 1